import React from 'react'
import injectStyles from 'react-jss'

import { getMetricResultForMissions } from 'Reducers/MetricResults/selectors'

import { numberFormatter } from '../../../../Utils/Formatters'
import BigCard from 'Components/Stats/BigCard'
import { styles } from './styles'

const BigCardsBlock = ({
  missions,
  metrics,
  totalFlyersDistributed,
  totalWeeks,
  bulletCharts,
  currencySign,
  classes,
}) => {
  const cardsData = [
    {
      value: numberFormatter(totalFlyersDistributed),
      text: 'Cards distributed',
      good: false,
      bad: false,
    },
    {
      value: numberFormatter(totalWeeks),
      text: 'Weeks',
      good: false,
      bad: false,
    },
  ]

  if (metrics.length > 0) {
    const metric = metrics.find(metric => metric.isPrimary) || metrics[0]
    const {
      totalMetricResults,
      totalFlyersDistributed,
    } = getMetricResultForMissions(missions)

    const metricResults = totalMetricResults[metric.id]
    cardsData.push({
      value: numberFormatter(metricResults),
      text: metric.name,
      good: false,
      bad: false,
    })

    cardsData.push({
      value:
        totalFlyersDistributed > 0
          ? ((metricResults / totalFlyersDistributed) * 100).toFixed(2) + '%'
          : 'N/A',
      text: `${metric.name} CVR`,
      good:
        metricResults / totalFlyersDistributed > metric.targetConversionRate,
      bad: metricResults / totalFlyersDistributed < metric.targetConversionRate,
    })

    if (missions.length == 0 || metricResults == 0) {
      cardsData.push({
        value: 'N/A',
        text: `${metric.name} CPM`,
        good: false,
        bad: false,
      })
    }
    const value = bulletCharts.costPerMetric
    const textValue = numberFormatter(value)
    cardsData.push({
      value: `${currencySign}${textValue}`,
      text: `Cost per ${metric.name}`,
      good: value < metric.targetCostPerMetric / 100,
      bad: value > metric.targetCostPerMetric / 100,
    })
  }

  return (
    <div className={classes.wrapper}>
      {cardsData.map(card => (
        <div className={classes.wrapperBigCard}>
          <BigCard
            value={card.value}
            text={card.text}
            good={card.good}
            bad={card.bad}
          />
        </div>
      ))}
    </div>
  )
}

export default injectStyles(styles)(BigCardsBlock)



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/BigCardsBlock/index.js